var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable complexity */
/*
* MixPanel tracking HOC
* Usage :
1) const trackedComponent = withTracking({
  page: "Your page if nay",
  contextId: <>
})(YourAtomComponent)
2) const trackedComponent = withTracking()(YourAtomComponent)
<YourAtomComponent eventActions={{
  onClick: {
  event: "Your event name",
  data: "Your event data object"  // can be object or function
  }
}}/>
*/
import { Component } from 'react';
import PropTypes from 'prop-types';
import { getBaseProperties } from '../saga';
import { withStore } from '@mindtickle/medux/Store';
import { mixpanelIdentity } from '../config';
import { isEmpty } from '@mindtickle/utils';
import mixpanelManager from '../helpers/mixpanelManager';
export var mixpanelClient = {
    track: function (event, data, sendUsingBeacon) {
        if (sendUsingBeacon === void 0) { sendUsingBeacon = false; }
        // eslint-disable-next-line
        console.log('MIX_PANEL EVENT: ', event, ', DATA: ', data, ', sendUsingBeacon: ', sendUsingBeacon); //eslint-disable-line
    },
};
var withTracking = function (injectedProps) {
    if (injectedProps === void 0) { injectedProps = {}; }
    return function (WrappedComponent) {
        var _a;
        var HOC = (_a = /** @class */ (function (_super) {
                __extends(HOC, _super);
                function HOC(props) {
                    var _this = _super.call(this, props) || this;
                    _this.createWrappedMethod = function (eventObj, eventAction) {
                        var event = eventObj.event, eventData = eventObj.data;
                        var self = _this;
                        var originalMethod = _this.props[eventAction];
                        _this.wrappedEvents[eventAction] = function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            var opData = originalMethod && originalMethod.apply(this, args);
                            var trackData = eventData;
                            var props = self.props; // get original props
                            var state = {}; // get origin state
                            if (typeof eventData === 'function') {
                                trackData = eventData.apply(this, __spread([opData, props, state], args));
                            }
                            self.fireTracking(event, trackData);
                        };
                        _this.setState({});
                    };
                    _this.wrapMethodsForFrameworkEvents = function () {
                        var eventActions = _this.props.eventActions;
                        for (var e in eventActions) {
                            var eventObj = eventActions[e];
                            _this.createWrappedMethod(eventObj, e);
                        }
                    };
                    _this.track = function (event, mixpanelData, sendUsingBeacon) {
                        if (sendUsingBeacon === void 0) { sendUsingBeacon = false; }
                        if (process.env.IS_DEV || process.env.isDev) {
                            mixpanelClient.track(event, mixpanelData, sendUsingBeacon);
                        }
                        else if (process.env.TRACKING) {
                            mixpanelManager.track(event, mixpanelData, sendUsingBeacon);
                        }
                    };
                    // static contextTypes = { store: PropTypes.object.isRequired };
                    _this.fireTracking = function (event, trackData, sendUsingBeacon) {
                        if (trackData === void 0) { trackData = {}; }
                        if (sendUsingBeacon === void 0) { sendUsingBeacon = false; }
                        var trackEvent = trackData.event, _contextId = trackData.contextId, rest = __rest(trackData, ["event", "contextId"]);
                        // Override event if event is runtime function of trackData
                        var __event = trackEvent || event;
                        // Do not track if no event presert
                        if (!__event) {
                            return;
                        }
                        var contextId = _contextId || _this.props.contextId || injectedProps.contextId;
                        var injectedTrackData = injectedProps.trackData;
                        var store = _this.props.store.store.getState();
                        var contextData = {};
                        if (contextId) {
                            var contextPath = (store[contextId] && store[contextId].mixpanel) || {};
                            contextData = getBaseProperties(contextPath, mixpanelIdentity.get(), store);
                        }
                        var mixpanelData = __assign(__assign({ contextData: contextData }, rest), injectedTrackData);
                        _this.track(__event, mixpanelData, sendUsingBeacon);
                    };
                    _this.wrappedEvents = [];
                    return _this;
                }
                HOC.prototype.componentDidMount = function () {
                    this.wrapMethodsForFrameworkEvents();
                };
                HOC.prototype.componentDidUpdate = function (prevProps) {
                    var eventActions = this.props.eventActions;
                    for (var e in eventActions) {
                        if (this.props[e] !== prevProps[e]) {
                            var eventObj = eventActions[e];
                            this.createWrappedMethod(eventObj, e);
                        }
                    }
                };
                HOC.prototype.render = function () {
                    var _a = this.props, eventActions = _a.eventActions, rest = __rest(_a, ["eventActions"]); // eslint-disable-line no-unused-vars
                    var trackProps = {};
                    if (!eventActions || isEmpty(eventActions)) {
                        trackProps.track = this.fireTracking;
                    }
                    return _jsx(WrappedComponent, __assign({}, rest, this.wrappedEvents, trackProps), void 0);
                };
                return HOC;
            }(Component)),
            _a.propTypes = {
                eventActions: PropTypes.object,
                contextId: PropTypes.string,
                store: PropTypes.object.isRequired,
            },
            _a);
        return withStore(HOC);
    };
};
export default withTracking;
//# sourceMappingURL=withTracking.js.map